import letterSpacings from './letterSpacings';

import type { LetterSpacings } from './letterSpacings';

/** @deprecated Use @m/components-ui/theme and Chakra semantic tokens instead. */
export type { LetterSpacings };

/** @deprecated Use @m/components-ui/theme and Chakra semantic tokens instead. */
export type Fonts =
  | (
      | 'light'
      | 'lightItalic'
      | 'regular'
      | 'italic'
      | 'medium'
      | 'mediumItalic'
      | 'bold'
      | 'boldItalic'
    )
  | string;

/** @deprecated Use @m/components-ui/theme and Chakra semantic tokens instead. */
export type FontSizes = {
  /** 16px */
  body: string;
  /** 17px */
  bodyMedium: string;
  /** 15px */
  bodySmall: string;
  /** 19px */
  bodyXLarge: string;
  /** 40px */
  h1: string;
  /** 36px */
  h2: string;
  /** 30px */
  h3: string;
  /** 24px */
  h4: string;
  /** 20px */
  h5: string;
  /** 18px */
  h6: string;
  /** 22px */
  headingSmall: string;
  /** 48px */
  huge: string;
  /** 32px */
  large: string;
  /** 14px */
  small: string;
  /** 12px */
  tiny: string;
  /** 44px */
  xLarge: string;
};

const fontSizes: FontSizes = {
  tiny: '12px',
  small: '14px',
  bodySmall: '15px',
  body: '16px',
  bodyMedium: '17px',
  h6: '18px',
  bodyXLarge: '19px',
  h5: '20px',
  headingSmall: '22px',
  h4: '24px',
  h3: '30px',
  large: '32px',
  h2: '36px',
  h1: '40px',
  xLarge: '44px',
  huge: '48px',
};

const typography = {
  fontSizes,
  letterSpacings,
};
/** @deprecated Use @m/components-ui/theme and Chakra semantic tokens instead. */
export default typography;
